import React, { useState } from 'react';
import { useOAuth } from '../../context/OAuthContext';
import './CharacterSelection.css';

const CharacterSelection = ({ characters, onCharacterSelected }) => {
  const { selectCharacter, loading, error } = useOAuth();
  const [selectedCharacterId, setSelectedCharacterId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSelect = async (characterId) => {
    if (submitting) return;

    setSelectedCharacterId(characterId);
    setSubmitting(true);

    try {
      const success = await selectCharacter(characterId);
      if (success) {
        onCharacterSelected();
      }
    } catch (err) {
      console.error('Error selecting character:', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (!characters || characters.length === 0) {
    return (
      <div className="character-selection">
        <p>No characters found. Please contact support.</p>
      </div>
    );
  }
  return (
    <div className="character-selection">
      {error && (
        <div className="character-selection-error">
          {error}
        </div>
      )}
      <div className="character-list">
        {characters.map((character) => (
          <div
            key={character.id}
            className={`character-card ${selectedCharacterId === character.id ? 'selected' : ''} ${character.isActive ? 'active' : ''}`}
            onClick={() => handleSelect(character.id)}
          >
            <div className="character-name">
              {character.firstname} {character.lastname}
            </div>
            <div className="character-status">
              {character.isActive || character.isActive === 1 ? 'ENABLED' : ''}
            </div>
            {submitting && selectedCharacterId === character.id && (
              <div className="character-loading">Selecting...</div>
            )}
          </div>
        ))}
      </div>

    </div>

  );
};

export default CharacterSelection;

